import classNames from 'classnames';
import React from 'react';

import {
  FULFILLMENT_STATUS_ICONS,
  FULFILLMENT_STATUS_NAMES,
  FulfillmentStatus,
  RequestSampleStatusCounts,
} from 'requests/fulfillments/FulfillmentConstants';
import Tooltip from 'ui-library/bs/Tooltip';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

function StatusCount({status, count}: {status: FulfillmentStatus; count: number}): JSX.Element {
  const statusIcon = FULFILLMENT_STATUS_ICONS[status];

  return (
    <Tooltip
      key={status}
      title={`${count} ${FULFILLMENT_STATUS_NAMES[status].toLowerCase()}`}
      delay={{show: 500, hide: 100}}
    >
      <div
        className={classNames('requestSampleStatusCounts-iconCount', {
          'requestSampleStatusCounts--noSamples': count === 0,
        })}
      >
        <BenchlingIcon
          className={classNames('requestSampleStatusCounts-icon', statusIcon.className)}
          icon={statusIcon.icon}
        />
        <span className="requestSampleStatusCounts-countText">{count}</span>
      </div>
    </Tooltip>
  );
}

export default function SampleStatusCounts({
  statusCounts,
}: {
  statusCounts: RequestSampleStatusCounts;
}): JSX.Element {
  // FAILED status is considered pending
  return (
    <div className="requestSampleStatusCounts-cell">
      <StatusCount
        status={FulfillmentStatus.PENDING}
        count={statusCounts[FulfillmentStatus.PENDING] + statusCounts[FulfillmentStatus.FAILED]}
      />
      <StatusCount
        status={FulfillmentStatus.IN_PROGRESS}
        count={statusCounts[FulfillmentStatus.IN_PROGRESS]}
      />
      <StatusCount status={FulfillmentStatus.COMPLETED} count={statusCounts[FulfillmentStatus.COMPLETED]} />
    </div>
  );
}
